import { Text } from 'components/UI/Typography/Text';

import styles from './NIlDealTrackerHeader.module.scss';

export const NilDealTrackerHeader = () => {
  return (
    <div className={styles.headerContainer}>
      <Text className={styles.playerHeader} variant="subtitle2">
        Player
      </Text>
      <Text className={styles.statusHeader} variant="subtitle2">
        Status
      </Text>
      <Text className={styles.partnerHeader} variant="subtitle2">
        Deal Partners
      </Text>

      <Text className={styles.dealHeader} variant="subtitle2">
        Deal
      </Text>
    </div>
  );
};
